module.exports = __webpack_public_path__ + "static/card-university-5d7495f8e7b0fc4319d7026ca17725b1.png";